import { NgModule } from '@angular/core';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';


@NgModule({
    imports: [AuthModule.forRoot({
        config: {
            authority: environment.authority,
            authWellknownEndpointUrl: environment.authWellknownEndpointUrl,
            redirectUrl: environment.authRedirectUrl,
            postLogoutRedirectUri: environment.authLogoutUrl,
            clientId: environment.authClientId,
            scope: 'openid offline_access',//CIAM returns all claims under scope openid + offline_access is required for refresh token by angular auth oidc client
            responseType: 'code',//code enables PKCE
            useRefreshToken: true,
            silentRenew: true,
            logLevel: LogLevel.Debug,
            secureRoutes: [
                environment.apiUrl, // current API host (e.g. https://dev.mib.motion.abb.com/api on custom domains)
                'https://abb-mose-mib-api-ui25.azurewebsites.net',
                'https://abb-mose-mib-api-dev.azurewebsites.net',
                'https://abb-mose-mib-api-test.azurewebsites.net',
                'https://abb-mose-mib-api-stage.azurewebsites.net',
                'https://abb-mose-mib-api.azurewebsites.net'
            ]
        }
    })],
    exports: [AuthModule],
})
export class AuthConfigModule { }
